export function isModuleAccessible(module: { isFree: boolean; isLocked: boolean }): boolean {
  if (module.isLocked) return false;
  return true;
}
